/*
 * Tap-to-open for the (i) tooltips in the cake and tasting configurators.
 * They were CSS-only (:hover / :focus), and a tap on a phone usually neither
 * hovers nor focuses a <span>. Several icons also sit inside <label>s, where
 * a tap focused the field instead. Tapping an icon now toggles its tooltip;
 * tapping anywhere else or pressing Escape closes it.
 */
(function () {
  if (window.__infoTooltipsReady) return;
  window.__infoTooltipsReady = true;

  var SELECTOR = '.custom-cake__info-icon, .tasting__info-icon';

  function closeAll(except) {
    document.querySelectorAll(SELECTOR + '.is-open').forEach(function (icon) {
      if (icon === except) return;
      icon.classList.remove('is-open');
      icon.setAttribute('aria-expanded', 'false');
    });
  }

  function toggle(icon) {
    var open = !icon.classList.contains('is-open');
    closeAll(icon);
    icon.classList.toggle('is-open', open);
    icon.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      // The configurator scripts nudge a tooltip back into the viewport on
      // mouseenter; reuse that on tap.
      icon.dispatchEvent(new Event('mouseenter'));
    } else if (document.activeElement === icon) {
      // On desktop a click also focuses the icon, which would keep the
      // tooltip visible through the :focus rule.
      icon.blur();
    }
  }

  function init(root) {
    root.querySelectorAll(SELECTOR).forEach(function (icon) {
      icon.setAttribute('role', 'button');
      icon.setAttribute('aria-expanded', icon.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var icon = event.target.closest && event.target.closest(SELECTOR);
    if (icon) {
      // Stops a label around the icon from moving focus to its field.
      event.preventDefault();
      toggle(icon);
      return;
    }
    closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    var icon = event.target.closest && event.target.closest(SELECTOR);
    if (icon && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      toggle(icon);
    } else if (event.key === 'Escape') {
      closeAll(null);
    }
  });

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
